import { render, staticRenderFns } from "./waitCustomer.vue?vue&type=template&id=1560784a&"
import script from "./waitCustomer.vue?vue&type=script&lang=js&"
export * from "./waitCustomer.vue?vue&type=script&lang=js&"
import style0 from "./waitCustomer.vue?vue&type=style&index=0&lang=less&"
import style1 from "./waitCustomer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports